import { AUTH_PROVIDERS } from '@packages/utils/enums'
import { sdk } from '@lib/sdk/sdk'

export const getAuthMethodsConfigs = (availableMethods: string[]) => {
  const isEvmCustomProvider = sdk.evm.isEvmProvider()
  return {
    oauth: {
      provider: AUTH_PROVIDERS.OAUTH,
      text: 'credenza auth',
      condition: availableMethods.some(method => method !== 'evm'),
    },
    evm: {
      provider: AUTH_PROVIDERS.EVM,
      text: 'EVM',
      condition: availableMethods.includes('evm') && isEvmCustomProvider,
    },
  }
}
